import type { MouseEvent } from "react";

const onClickPreventDefault = (event: MouseEvent<HTMLElement>) => {
  event.preventDefault();
};

export default onClickPreventDefault;
